import type {
  GetUserWatchlistsResponse,
  Watchlist,
} from "@foundation/watchlist-client";
import { PortfolioForm } from "~types/portfolio";
import { createPortfolio } from "~api/portfolio/portfolioData";
import { prepareCreatePortfolioData } from "~utils/portfolio/hydratePortfolioData";

export const savePortfolio = async (
  formData: PortfolioForm,
  bconnectId: string
): Promise<Watchlist> => {
  try {
    // create new portfolio
    const newPortfolioData = prepareCreatePortfolioData(formData);

    return await createPortfolio(bconnectId, newPortfolioData).then(
      (response) => (response.data as GetUserWatchlistsResponse).port
    );
  } catch (error) {
    throw error;
  }
};
